import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"

interface DisabledFieldProps extends React.HTMLAttributes<HTMLSpanElement> {
  isDisabled: boolean
}
export const ConceptoField = ({ children, isDisabled }: DisabledFieldProps) => {
  const { t } = useTranslation()
  const disabledClass = isDisabled
    ? "tw-flex tw-flex-col tw-font-normal tw-bg-gray-50 !tw-h-full tw-items-left tw-justify-start tw-text-gray-400 tw-italic [&_.tw-text-secondary]:tw-text-gray-400"
    : ""

  return (
    <span className={`${disabledClass}`}>
      {children}
      {isDisabled && (
        <span className='tw-bg-warning-10 tw-text-warning tw-rounded-full tw-px-1 tw-text-xs tw-font-normal tw-w-fit'>
          <FontAwesomeIcon
            icon={faInfoCircle}
            className='tw-mr-1'
          />
          {t("bancos.idView.table.provisionalMovement")}
        </span>
      )}
    </span>
  )
}
